import { Route } from '@angular/router';
import { UpgradeComponent } from './upgrade.component';

export const UpgradeRoutes: Route[] = [
  {
    path: 'upgrade',
    component: UpgradeComponent
  },
  {
    path: 'account/upgrade',
    component: UpgradeComponent
  },
];
